import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintEdi.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintEdi_datex_order_info_to_generic_warehouse_receipt_xmlService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { project_lookups: string[], days?: number, shipment_type?: number, transaction_type?: string, integration_id?: string, has_order_transmissions?: boolean, in_transmission_type?: string, out_transmission_type?: string }): Promise<{ results?: any[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.project_lookups)) {
      $missingRequiredInParams.push('\'project_lookups\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

